import React, { Component } from 'react';
import {func, string} from 'prop-types';
import Query from 'apps/admin/util/query';
import CreateOrganizationMutation from '../pages/journey-map/queries/create-organization-mutation';
import '../styles/components/create-organization-form.scss';

class CreateOrganizationForm extends Component {
  state = {
    organization_name: ''
  }

  handleChange = (e) => {
    const { 
      name, 
      value 
    } = e.target;
    
    this.setState({
      [name]: value
    });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const {
      organization_name
    } = this.state;

    try {
      const { data } = await Query(CreateOrganizationMutation(organization_name));

      if (data['create_organization'].success) {
        await this.props.reloadOrganizations();
        this.props.toggleActive();
      }

    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const {
      toggleActive
    } = this.props;
    
    return (
      <div className="create-organization-form-body">
        <form onSubmit={this.handleSubmit}>
          <label>
            Organization Name
            <input name='organization_name' type='text' onChange={this.handleChange} />
          </label>
          <div className='button-container'> 
            <button className='create-organization-button' type='submit'>Create Organization</button>
            <button className='create-organization-button' type='button' onClick={ toggleActive }>Cancel</button>
          </div>
        </form>
      </div>
    );
  }
}

CreateOrganizationForm.propTypes = {
  toggleActive: func,
  reloadOrganizations: func,
  organization_name: string
};

export default CreateOrganizationForm;
